import colors from '../../constants/colors'

const rightBorderStyle = {
  borderRight: `2px solid ${colors.TAG_BORDER_BLUE}`,
}

const itemStyle = {
  paddingLeft: '3.2rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'start',
  fontFamily: 'Aktiv Grotesk, sans-serif',
}

const selectStyle = {
  '&.MuiSelect-outlined , .MuiOutlinedInput-input': {
    p: '.8rem',
    marginTop: 0,
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  '&.MuiSelect-root , .MuiSelect-icon': {
    top: 'auto !important',
    right: '1.2rem',
  },
  height: '100%',
}

export default {
  rightBorderStyle,
  itemStyle,
  selectStyle,
}
